import { useMemo } from 'react';

import type { VolumeSummary } from '../../hooks/useAutoscaleRulesQuery';

interface UseFilteredVolumesParams {
  volumes: VolumeSummary[];
  selectedVolumeType: 'supported' | 'notSupported';
  searchQuery: string;
}

export function useFilteredVolumes({
  volumes,
  selectedVolumeType,
  searchQuery,
}: UseFilteredVolumesParams) {
  return useMemo(() => {
    if (!searchQuery.trim()) {
      return volumes;
    }

    const query = searchQuery.toLowerCase();
    return volumes.filter(
      (volume) =>
        volume.volumeId?.toLowerCase().includes(query) ||
        volume.instanceId?.toLowerCase().includes(query)
    );
  }, [volumes, selectedVolumeType, searchQuery]);
}
